// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"style__tabBar__y0OHB","clear":"style__clear__fdOcx"};